export default __webpack_public_path__ + "static/media/IIT-MathFin-RobustRL-2024.ab38d4da.pdf";